import tw, { styled } from "twin.macro";
import { ECheckoutSource } from "@/utils/checkoutType";
import { type TSourceType } from ".";
import Paragraph from "@/components/Atoms/Paragraph";

interface IStyledOriginTagProps {
  $source: ECheckoutSource;
  $type: TSourceType;
}

const styles = {
  root: {
    typeBase: {
      bagged: tw`rounded-s transition-all border px-3`,
      flat: tw`flex items-center gap-1`,
    },

    variants: {
      bagged: {
        [ECheckoutSource.INTERNATIONAL]: tw`bg-blue-150 border-blue-200 py-1`,
        [ECheckoutSource.LOCAL]: tw`bg-primaryV2-90 border-primaryV2-70 py-1`,
      },
      flat: {
        [ECheckoutSource.INTERNATIONAL]: tw`text-blue-250`,
        [ECheckoutSource.LOCAL]: tw`text-primaryV2-60`,
      },
    },
  },
  text: {
    source: {
      [ECheckoutSource.INTERNATIONAL]: tw`text-blue-250`,
      [ECheckoutSource.LOCAL]: tw`text-primaryV2-40`,
    },
  },
};

export const StyledOriginTag = styled.div<IStyledOriginTagProps>(({ $type, $source }) => [
  tw`flex gap-1 items-center`,
  // style baase for type
  styles.root.typeBase[$type],
  // style variants for type
  styles.root.variants[$type][$source],
]);

export const StyledText = styled(Paragraph)<IStyledOriginTagProps>`
  ${({ $source }) => styles.text.source[$source]}

  ${({ $type }) => $type === "flat" && tw`italic`}
`;
